var module = angular.module('octopusApp.infrastructure');

module.directive('helpButton', function (helpManager) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
    },
    templateUrl: 'infrastructure/directives/views/help-button.html',
    link: function (scope, element) {
      scope.helpManager = helpManager;
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/help_button.js
// module id = 5218330813865421
// module chunks = 1